<div *ngIf="isLoading" class="loading-modal-spinner">
    <owc-progress-spinner />
</div>